import type { HelpFaqProps } from '@/components/help/HelpFaq';
import { HelpFaq } from '@/components/help/HelpFaq';

const helpFaqData: HelpFaqProps = {
  title: 'Supplements & Refills',
  subtitle: 'Adding or changing supplements',
  faq: [
    {
      question: 'Automatic refills',
      answer: (
        <>
          <p>
            As part of your service, we work with your doctors to renew your
            supplement subscription before you need them.
          </p>
          <h3>How we refill</h3>
          <p>
            About three weeks before the end of your subscription - or three
            weeks prior to the completion of one year from your first order or
            the most recent update of your subscription in the case of
            indefinite-term subscriptions - we will reach out to you and your
            doctor to adjust your supplement subscription. Once we get your
            updated health data, you will be presented with an adjusted
            subscription offer - if you confirm the order, your next
            subscription delivery will be assembled in accordance with the
            confirmed order.
          </p>
          <p>
            In cases of fixed-term subscriptions, confirming the order shall
            also mean the confirmation of your fixed-term subscription renewal
            for the same period as before.
          </p>
          <h3>We might ask for your help</h3>
          <p>
            There will be times{' '}
            <strong>when your doctor needs more information</strong> before
            renewing a supplement subscription. For example, they may want you
            to get lab work or stop by for an office visit. When this happens,
            we'll email or call you.
          </p>
          <p>
            If you ever have questions about the status of a prescription,
            please don't hesitate to contact us. We're happy to help.
          </p>
        </>
      ),
    },
    {
      question: '30-day schedule',
      answer: (
        <>
          <p>
            We fill supplement subscriptions on a 30-day cycle, rather than
            90-day. This is because we understand supplements, strengths, and
            doses may change. Filling monthly allows us to quickly accommodate
            any adjustments for your next order. That way, you don't have to
            throw out two months of supplements any time there's a change.
          </p>
          <p>
            If your doctor is used to writing 90-day prescriptions, they can
            continue to do so. We'll dispense it on a 30-day schedule for you.
          </p>
        </>
      ),
    },
  ],
};

export const SupplementsRefillsPage = () => {
  return <HelpFaq {...helpFaqData} />;
};
